{
  "trigger_button": "Add",
  "title": "✨ Add to your schedule",
  "poll_title": "✨ Add Event Titles, Dates & Times",
  "manual_entry": "Add manually instead",
  "do_later": "I'll do this later",
  "tip": "💡️ <strong>Tip:</strong> You can add a single or multiple items at one time!",
  "placeholder": "Type or paste text to convert into schedule items!",
  "poll_placeholder": "Example:\n\nWeek 1 Saturday Rehearsal, June 5, 2027, 1pm-5pm\nWeek 1 Sunday Rehearsal, June 6, 2027, 11am-3pm",
  "submit": "🪄 Create",
  "error": "Error creating items. Please try again.",
  "add_content_header": {
    "title": "Welcome to your new schedule!",
    "byline": "Get started by adding some content.",
    "tip": "💡️ <strong>Tip:</strong> You can add a single or multiple items at one time!"
  },
  "onboarding_header": {
    "title_line_1": "✨ Let's add some content ✨",
    "title_line_2": "to your schedule",
    "tip": "💡️ <strong>Tip:</strong> You can add a single or multiple items at one time!"
  },
  "delete_confirm": "Delete {{name}}?",
  "loading_state": {
    "title": "Working our magic",
    "slide_1_message": "More time means more fun with rainbows, unicorns, and all the magical things in life",
    "slide_2_message": "Anything is possible if you believe in magic, wonder, and the power of luck dragons",
    "slide_3_message": "Keep reaching for the stars... or the alien planets. Who knows what's out there?",
    "slide_4_message": "Believe in the magic inside of you, and you can do anything!",
    "slide_5_message": "A beautiful schedule is like a roadmap to awesome-ville, and you're the driver!"
  },
  "success_state": {
    "title": "All items have been added to your schedule!",
    "close": "Return to your schedule",
    "title_form": "All items have been added to your form!",
    "close_form": "Return to your form",
    "or": "or",
    "add_more": "add more"
  },
  "empty_state": {
    "title": "No items to display!",
    "close": "Return to your schedule",
    "or": "or",
    "add_more": "add more"
  },
  "close_confirm": {
    "title": "None of these items will be added if you close, are you sure you want to continue?",
    "confirm": "Close anyway",
    "cancel": "Go back"
  },
  "panel": {
    "heading": "Magic",
    "title": "Add to your page",
    "footer": "Nothing is added until you review",
    "clear": "Clear and start new",
    "close": "Close",
    "quick_edits": {
      "intro": "Tell me what to add or change on {{title}}. Watch your schedule update as we go.",
      "placeholder": "Tell me what to add or change",
      "footer": "Changes apply to your page as we go."
    }
  },
  "header_card": {
    "title": "Voila! Results below",
    "byline": "Review and edit as needed",
    "add_one": "Add to schedule",
    "add_other": "Add all {{count}} to schedule",
    "loading_text": "Adding to schedule...",
    "add_form_one": "Add to form",
    "add_form_other": "Add all {{count}} to form",
    "loading_text_form": "Adding to form..."
  },
  "events_out_of_range_modal": {
    "title": "Events added.",
    "subtitle_added": "They're saved to your schedule.",
    "subtitle_outside": "They're saved to your plan, but outside the dates you're viewing.",
    "subtitle_past": "They're saved to your plan, but they're in the past, outside the dates you're viewing.",
    "subtitle_year": "They're saved to your plan, but they're in {{year}}, a different year than the one you're viewing.",
    "subtitle_outside_plan": "They're saved, but they fall outside your plan's date range, so no view will show them.",
    "outside_plan_help": "Widen the range under Schedule settings to bring them in.",
    "subtitle_upcoming_only": "They're saved, but this view is set to show future events only, so these past events won't appear.",
    "upcoming_only_help": "Switch it to show all events, or edit these to be in the future.",
    "title_filtered": "Nothing to show here.",
    "subtitle_filtered_one": "{{count}} event falls in the dates you're viewing, but it doesn't match your filters.",
    "subtitle_filtered_other": "{{count}} events fall in the dates you're viewing, but none of them match your filters.",
    "subtitle_filtered_empty": "There are no events at all in the dates you're viewing, matching or not.",
    "subtitle_filtered_hidden_one": "{{count}} event falls in the dates you're viewing, but it's hidden on this view.",
    "subtitle_filtered_hidden_other": "{{count}} events fall in the dates you're viewing, but they're all hidden on this view.",
    "filtered_next_match": "Your filters do match events elsewhere on this schedule, starting {{date}}.",
    "filtered_no_match": "Nothing anywhere else on this schedule matches them either.",
    "clear_filters": "Clear filters",
    "count_one": "{{count}} event",
    "count_other": "{{count}} events",
    "repeats_daily": "repeats daily",
    "repeats_weekly": "repeats weekly",
    "repeats_monthly": "repeats monthly",
    "repeats_yearly": "repeats yearly",
    "repeats_generic": "repeats",
    "repeats_multiple": "includes repeating events",
    "dismiss": "Got it",
    "jump": "Jump to first event added",
    "edit": "Edit event"
  },
  "delete_error": "Error deleting item",
  "aria_edit": "Edit",
  "aria_messages": "Add a message",
  "aria_remove": "Remove",
  "aria_texts": "Texts",
  "planner_modal": {
    "chat_to_edit": "Chat to edit",
    "success_title": "All items have been added!",
    "success_close": "Done"
  }
}
